import React from 'react';
import { Link } from 'react-router-dom';
import one from '../../../images/user/1.jpg';
import two from '../../../images/user/2.png';
import eight from '../../../images/user/8.jpg';
import four from '../../../images/user/4.jpg';
import five from '../../../images/user/5.jpg';
import six from '../../../images/user/6.jpg';
import seven from '../../../images/user/7.jpg';
import {
  FRIENDLIST, Online, VincentPorter, EricaHughes, AinChavez, HileriJecno, GingerJohnston, PrasanthAnand, KoriThomas,
} from '../../constant';
import RightSidebarDrawer from '../RightSidebarDrawer';
import NotificationStatus from '../../components/NotificationStatus';

const ChatSidebar = () => (
  <div>
    <div className="friend-list-search mt-0">
      <RightSidebarDrawer
        title={FRIENDLIST}
        className="friend-list-search"
      >
        <div className="people-list friend-list">
          <ul className="list">
            <li className="clearfix">
              <Link to={`${process.env.PUBLIC_URL}/chat-app/chat`}>
                <img className="rounded-circle user-image" src={one} alt="" />
                <div className="status-circle online" />
                <div className="about">
                  <div className="name">{VincentPorter}</div>
                  <div className="status">
                    {' '}
                    {Online}
                  </div>
                </div>
              </Link>
            </li>
            <li className="clearfix">
              <Link to={`${process.env.PUBLIC_URL}/chat-app/chat`}>
                <img className="rounded-circle user-image" src={two} alt="" />
                <div className="status-circle away" />
                <div className="about">
                  <div className="name">{AinChavez}</div>
                  <div className="status">
                    {' '}
                    28 minutes ago
                  </div>
                </div>
              </Link>
            </li>
            <li className="clearfix">
              <Link to={`${process.env.PUBLIC_URL}/chat-app/chat`}>
                <img className="rounded-circle user-image" src={eight} alt="" />
                <div className="status-circle online" />
                <div className="about">
                  <div className="name">{KoriThomas}</div>
                  <div className="status">
                    {' '}
                    {Online}
                  </div>
                </div>
              </Link>
            </li>
            <li className="clearfix">
              <Link to={`${process.env.PUBLIC_URL}/chat-app/chat`}>
                <img className="rounded-circle user-image" src={four} alt="" />
                <div className="status-circle online" />
                <div className="about">
                  <div className="name">{EricaHughes}</div>
                  <div className="status">
                    {' '}
                    {Online}
                  </div>
                </div>
              </Link>
            </li>
            <li className="clearfix">
              <Link to={`${process.env.PUBLIC_URL}/chat-app/chat`}>
                <img className="rounded-circle user-image" src={five} alt="" />
                <div className="status-circle offline" />
                <div className="about">
                  <div className="name">{GingerJohnston}</div>
                  <div className="status">
                    {' '}
                    2 minutes ago
                  </div>
                </div>
              </Link>
            </li>
            <li className="clearfix">
              <Link to={`${process.env.PUBLIC_URL}/chat-app/chat`}>
                <img className="rounded-circle user-image" src={six} alt="" />
                <div className="status-circle away" />
                <div className="about">
                  <div className="name">{PrasanthAnand}</div>
                  <div className="status">
                    {' '}
                    2 hour ago
                  </div>
                </div>
              </Link>
            </li>
            <li className="clearfix">
              <Link to={`${process.env.PUBLIC_URL}/chat-app/chat`}>
                <img className="rounded-circle user-image" src={seven} alt="" />
                <div className="status-circle online" />
                <div className="about">
                  <div className="name">{HileriJecno}</div>
                  <div className="status">
                    {' '}
                    {Online}
                  </div>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </RightSidebarDrawer>
    </div>
  </div>
);

export default ChatSidebar;
